import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import loginService from './components/loginService.js'
import userService from "@/components/userService"
import customModelingElementService from '@/components/customModelingElementsService'
import folderService from "@/components/folder-service"

Vue.use(Vuex);

function b64EncodeUtf8(str) {
    // btoa can only handle ASCII strings, so we need to encode the string as UTF-8 first.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        (_, hex) => String.fromCharCode(parseInt(hex, 16))
    ));
}

const getDefaultState = () => {
    return {
        token: '',
        customShareAuthToken: '',
        user: {},
        customModelingElements: {},
        clientColor: 'FFFFFF',
        clientIcon: "",
        currentUser: {},
    };
};

export default new Vuex.Store({
    strict: true,
    state: getDefaultState(),
    plugins: [createPersistedState()],
    getters: {
        isLoggedIn: state => !!state.token,
        token: state => state.token,
        customShareAuthToken: state => state.customShareAuthToken,
        user: state => state.user
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_CUSTOM_SHARE_AUTH_TOKEN: (state, customShareAuthToken) => {
            state.customShareAuthToken = customShareAuthToken;
        },
        SET_USER: (state, user) => {
            state.user = user;
        },
        SET_CURRENT_USER: (state, user) => {
            state.currentUser = user;
        },
        RESET: state => {
            Object.assign(state, getDefaultState());
        },
        ADD_MODELING_ELEMENT: (state, element) => {
            if(state.customModelingElements == null) state.customModelingElements = {}
            let elementName = "create."+element.taskType;
            element.title = element.elementTitle;
            element.group = element.elementGroup;
            state.customModelingElements[elementName] = element;
        },
        RESET_MODELING_ELEMENTS: (state, elements) => {
            state.customModelingElements = {}
            elements.forEach(element => {
                let elementName = "create."+element.taskType;
                element.title = element.elementTitle;
                element.group = element.elementGroup;
                state.customModelingElements[elementName] = element;
            });
        },
        SET_CLIENT_COLOR: (state, color) => {
            state.clientColor = color;
        },
        SET_CLIENT_ICON: (state, icon) => {
            state.clientIcon = icon;
        },
    },
    actions: {
        async hasRole({commit}, payload){
            const res = await userService.checkRoleForCurrentUser(payload);
            return res.data;
        },
        async hasPermission({commit}, payload){
            const res = await userService.retrieveRolesForUser();
            
            const userPermissions = res.data.map(elem => elem.permissions);
            var hasPermission = false;
            userPermissions.forEach(elem => {
                for(let key in elem){
                    if((elem[key] && key === payload.toUpperCase()) || (elem[key] && key === "ADMIN")){
                        hasPermission = true;
                    }  
                }
            })
            return hasPermission;
        },
        async checkFolderPermission({commit}, payload){
            const res = await folderService.checkPermissionForFolder(payload.processId, payload.permission);
            return res.data;
        },
        logout: ({ commit }) => {
            commit('RESET', '');
        },
        setClientColor: ({commit}, color) => {
            commit('SET_CLIENT_COLOR', color);
        },
        setClientIcon: ({commit}, icon) => {
            commit('SET_CLIENT_ICON', icon);
        },
        setToken: ({commit}, token) => {
            commit('SET_TOKEN', token);
        },
        setCustomShareAuthToken: ({commit}, customShareAuthToken) => {
            commit('SET_CUSTOM_SHARE_AUTH_TOKEN', customShareAuthToken);
        },
        async authenticateUser({ commit }, payload) {
            
            let user = { username: payload.username };
            const result = await loginService.authenticateUser(payload.username, payload.password);
            const clientId = result.data;
            if (clientId >= 0) {

                const token = b64EncodeUtf8(payload.username + ':' + payload.password + ':'+ clientId);
                commit('SET_TOKEN', token);
                commit('SET_USER', user);
                userService.retrieveUser(user.username).then((res) => {
                    res.data.currentClientId = clientId;
                    commit('SET_CURRENT_USER', res.data);
                  });
            } else {
                throw new Error('Validation Error');
            }
        },
        async addModelingElement({commit}, element){
            let fieldName = element.taskType.toLowerCase();
            const newElement = {
                    elementGroup: 'activity',
                    elementTitle: fieldName,
                    imageUrl: element.icon,
                    taskType: element.taskType.toUpperCase(),
                  }
            let res = await customModelingElementService.addCustomModelingElement(newElement);
            newElement.id = res.data;
            commit('ADD_MODELING_ELEMENT', newElement);        
        },
        async removeModelingElement({commit}, id){
            await customModelingElementService.removeCustomModelingElement(id);
            const elements = await customModelingElementService.getCustomModelingElements();
            commit('RESET_MODELING_ELEMENTS', elements.data);
        },
        initModelingElements({commit}, elements){
            elements.forEach(elem => {
                commit('ADD_MODELING_ELEMENT', elem);
            })
        },
        async changeCurrentClient({commit}, newClientId){
            await userService.changeCurrentClientForUser(newClientId);
            const decodedToken = this.state.token.replace("Basic ", "");
            const tokenParts = atob(decodedToken).split(":");
            const newToken = window.btoa(tokenParts[0] + ':' + tokenParts[1] + ':'+ newClientId);
            commit('SET_TOKEN', newToken);

            let user = await userService.retrieveUser(this.state.currentUser.userId);
            user.data.currentClientId = newClientId;
            commit('SET_CURRENT_USER', user.data);
        }
    }
});